import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { DecimalPipe } from '@angular/common';
import { CaseDto } from '../../../shared/Models/CaseDto';

@Component({
  selector: 'debtor-panel-order-contact-success',
  templateUrl: './order-contact-success.component.html',
  styleUrls: ['./order-contact-success.component.scss'],
  imports: [TranslateModule, MatCardModule, DecimalPipe],
})
export class OrderContactSuccessComponent {
  public date = input.required<Date>();
  public case = input.required<CaseDto | undefined>();

  protected parsedDay = computed(() => this.date()?.toLocaleString('pl-PL', { day: 'numeric', month: '2-digit', year: 'numeric' }));
  protected time = computed(() => this.date()?.toLocaleString('pl-PL', { hour: 'numeric', minute: 'numeric' }));
}
